import XLSX from 'xlsx-community';

export const exportAsCSV = (data, title, combinedColumns, csv, useSemicolon = false) => {

  if (!data[0]) { return; }
  const filteredColumns = combinedColumns.filter(column => !column.excludeFromExcel && column.title !== '#');

  const rows = [
    [ ...filteredColumns.map(column => (
      {
        v: column.title,
        t: 's',
        s: {
          fill: { fgColor: { rgb: '4472C4' } },
          font: {
            bold: true,
            color: { rgb: 'FFFFFF' },
            numFmt: '0',
            alignment: { wrapText: true },
            fitToWidth: 10
          }
        }
      }
    )) ],


    ...(data.map((record, index) => filteredColumns.map(column => {
      if (column.render) {
        // return `${column.render(record[column.dataIndex], record)}`;
        return {
          // v: column.render(`${record[column.dataIndex]}`, record),
          v: column.render(record[column.dataIndex], record),
          t: 's',
          s: {
            fill:
              index % 2 === 0 && {
                fgColor: { rgb: 'CBDCFA' }
              }
          }
        };
      }

      // return `${record[column.dataIndex]}`;
      return {
        v: record[column.dataIndex] ?? '',
        t: 's',
        s: { fill: index % 2 === 0 && { fgColor: { rgb: 'CBDCFA' } } }
      };

    })))
  ];
  const workbook = XLSX.utils.book_new();
  const worksheet = XLSX.utils.aoa_to_sheet(rows);
  workbook.SheetNames.push('Sheet1');
  workbook.Sheets.Sheet1 = worksheet;
  const csvOptions = { bookType: 'csv', FS: useSemicolon ? ';' : ',' };
  if (csv) { XLSX.writeFile(workbook, `${title}.csv`, csvOptions); } else {
    XLSX.writeFile(workbook, `${title}.xlsx`);
  }
};
